import type { JSX } from "react";
import { KeyboardShortcutsPanel } from "@grackle-ai/web-components";

/** Settings tab displaying the keyboard shortcuts reference. */
export function SettingsShortcutsTab(): JSX.Element {
  return <KeyboardShortcutsPanel />;
}
